import React from 'react';
import EntityModal from '../common/EntityModal';
import ContactForm from './ContactForm';

const ContactModal = ({ isOpen, onClose, contact = null, onSubmit, loading = false }) => (
  <EntityModal
    isOpen={isOpen}
    onClose={onClose}
    entity={contact}
    entityName="Contact"
    FormComponent={ContactForm}
    onSubmit={onSubmit}
    loading={loading}
    size="md"
  />
);

export default ContactModal;
